import { render } from "./completed.vue?vue&type=template&id=5c517e3c"
import script from "./completed.vue?vue&type=script&lang=js"
export * from "./completed.vue?vue&type=script&lang=js"

import exportComponent from "/app/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__